<template>
    <div>
        <div
            v-for="(point, key) in item.geometry.coordinates"
            :key="'point-' + key"
        >
            <l-marker
                :lat-lng="getCoordinates(point)"
                @click="openModal(point)"
            >
                <l-icon
                    :icon-url="marker"
                    :icon-size="iconSize"
                    :icon-anchor="[15.375, 37.5]"
                    ><img :src="marker" class="marker-icon"
                /></l-icon>
            </l-marker>
        </div>
    </div>
</template>
<script>
import { latLng } from "leaflet";
import { LIcon, LMarker } from "vue2-leaflet";

export default {
    name: "MultiPointMarkerComponent",
    components: {
        LMarker,
        LIcon,
    },

    props: {
        item: {
            default: () => {},
        },
        iconSize: {
            default: () => [30.75, 37.5],
        },
    },

    computed: {
        marker() {
            if (this.item.event_or_works_class === "_danger") {
                return "/svg/map/markers/conditions/hac-danger.svg";
            } else {
                return "/svg/map/markers/conditions/hac-warning.svg";
            }
        },
    },

    methods: {
        getCoordinates(coordinates) {
            return latLng(coordinates);
        },
        openModal(coordinates) {
            this.$parent.$parent.$parent.$refs.map.mapObject.setView(
                coordinates,
                12
            );

            this.$store.commit("setData", {
                name: "selectedCondition",
                data: this.item,
            });
        },
    },
};
</script>
